/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Failed_To_Extract_Audio_From_Source_VideoInputs */

const en_failed_to_extract_audio_from_source_video = /** @type {(inputs: Failed_To_Extract_Audio_From_Source_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to extract audio from source video. ${i?.error}`)
};

const fr_failed_to_extract_audio_from_source_video = /** @type {(inputs: Failed_To_Extract_Audio_From_Source_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’extraction audio de la vidéo source. ${i?.error}`)
};

const de_failed_to_extract_audio_from_source_video = /** @type {(inputs: Failed_To_Extract_Audio_From_Source_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audioextraktion aus dem Quellvideo fehlgeschlagen. ${i?.error}`)
};

const it_failed_to_extract_audio_from_source_video = /** @type {(inputs: Failed_To_Extract_Audio_From_Source_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile estrarre l'audio dal video sorgente. ${i?.error}`)
};

const ru_failed_to_extract_audio_from_source_video = /** @type {(inputs: Failed_To_Extract_Audio_From_Source_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось извлечь звук из исходного видео. ${i?.error}`)
};

const es_failed_to_extract_audio_from_source_video = /** @type {(inputs: Failed_To_Extract_Audio_From_Source_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo extraer el audio del vídeo de origen. ${i?.error}`)
};

const zh_cn2_failed_to_extract_audio_from_source_video = /** @type {(inputs: Failed_To_Extract_Audio_From_Source_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法从源视频中提取音频。${i?.error}`)
};

const ja_failed_to_extract_audio_from_source_video = /** @type {(inputs: Failed_To_Extract_Audio_From_Source_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ソースビデオからオーディオを抽出できませんでした。${i?.error}`)
};

const hi_failed_to_extract_audio_from_source_video = /** @type {(inputs: Failed_To_Extract_Audio_From_Source_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्रोत वीडियो से ऑडियो निकालने में विफल। ${i?.error}`)
};

const pt_pt2_failed_to_extract_audio_from_source_video = /** @type {(inputs: Failed_To_Extract_Audio_From_Source_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao extrair o áudio do vídeo de origem. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to extract audio from source video. {error}" |
*
* @param {Failed_To_Extract_Audio_From_Source_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_to_extract_audio_from_source_video = /** @type {((inputs: Failed_To_Extract_Audio_From_Source_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Extract_Audio_From_Source_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_failed_to_extract_audio_from_source_video(inputs)
	if (locale === "de") return de_failed_to_extract_audio_from_source_video(inputs)
	if (locale === "it") return it_failed_to_extract_audio_from_source_video(inputs)
	if (locale === "ru") return ru_failed_to_extract_audio_from_source_video(inputs)
	if (locale === "es") return es_failed_to_extract_audio_from_source_video(inputs)
	if (locale === "zh-CN") return zh_cn2_failed_to_extract_audio_from_source_video(inputs)
	if (locale === "ja") return ja_failed_to_extract_audio_from_source_video(inputs)
	if (locale === "hi") return hi_failed_to_extract_audio_from_source_video(inputs)
	if (locale === "pt-PT") return pt_pt2_failed_to_extract_audio_from_source_video(inputs)
	return en_failed_to_extract_audio_from_source_video(inputs)
});